import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FileConversionService {
  constructor() {}

  async convertFilesToBase64(files: File[]): Promise<string[]> {
    const base64Array: string[] = [];

    for (const file of files) {
      const base64String = await this.fileToBase64(file);
      base64Array.push(base64String);
    }

    return base64Array;
  }

  private fileToBase64(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = reader.result as string;
        resolve(base64String);
      };
      reader.onerror = error => {
        reject(error);
      };
    });
  }
}
